import React from 'react'
import { useState } from "react";
import axios from 'axios'
import { Markup } from 'interweave';
import Loader from "react-loader-spinner";
import { TERMINOSLEGALES } from '../../global/const'


const TerminosLegales = (props) => {
    const [open, setOpen] = useState();
    const [tipo, setTipo] = useState(0);
    const [texto, setTexto] = useState("");
    const [loader, setLoader] = useState(false);
    // React.useEffect(() => {
    //     setLoader(false)
    // }, [texto])
    React.useEffect(() => {
        window.scrollTo(0, 0);
        setLoader(true)
        getTerminosLegales();
    }, [])

    const getTerminosLegales = () => {
        setLoader(true)
        axios.get(TERMINOSLEGALES + `${props.tipoDoc}`)
            .then((res) => {
                setTexto(res.data)
                setLoader(false)

            }).catch((error) => {
                console.log(error);
            })
    }
    
    return (
        <div className="bodyTerminosLegales" >
            <a href="#openModal"></a>

            <>
                <div id="openModal" className="modalDialog ">
                    {
                        loader ?
                            <div className="loader_centerPages" style={{ height: "98vh" }}>
                                <Loader
                                    type="ThreeDots"
                                    color="#0075BB"
                                    height={100}
                                    width={100}

                                />
                            </div> :

                            <div className="div">
                                <a onClick={() => props.updateShowModal(false)} title="Close" className="close">X</a>
                                <div className="gradiente">
                                    <h4>{texto.nombre}</h4>.
                                </div>
                                <div className="cuerpo overflow-auto scrollSlider">

                                    <Markup content={texto.texto} />
                                </div>
                            </div>
                    }

                </div>

            </>

        </div>
    )
}

export default TerminosLegales;